import styled, { css } from 'styled-components';
import Label from 'components/Input/Label';
import { ifProp, prop } from 'styled-tools';

const FormLabel = styled(Label)`
  ${ifProp(
    'isHostBooking',
    css`
      @media screen and (max-width: ${prop('theme.breakpoints.extraLarge')}) {
        font-size: 0.65em;
      }
    `
  )}
`;

export default FormLabel;
